/**
 * contact.jsx
 * import axios for server calls
 * import button from react boostrap for styling
 * import Form form react boostrap for form and stylign
 * import ErrorMessage for displaying error messages
 * import SuccMessage for displaying succ messages
 * import Row and Col form react bootstrap for organization of display
 * difference from contact.jsx is that this form will display user's name
 */
import React, {useState, useEffect} from 'react';
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import '../../style/contactPage.css';
import ErrorMessage from './ErrorMessage';
import SuccMessage from './succMessage';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function ContactLoggedIn() {
    const [errorMessage, setErrorMessage] = useState(null);
    const [succMessage, setSuccMessage] = useState(null);
    const [userName, setUserName] = useState("");
    const loggedInUser = getCookie("link2rsvp");

    useEffect(() => {
        getName();
    });

    //Cookie
    //getting user cookie to display user's name
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return null;
      }
    //End of Cookie
    /**
     * function getName()
     * takes info from user cookie and request the server for the user name
     */
    async function getName() {
        const loggedUser = {
            email: loggedInUser
        }
        const user = await axios.post("https://link2rsvp.herokuapp.com/auth/loggedin", loggedUser);
        setUserName(user.data);
    }
    /**
     * function contactUs()
     * takes in user's email and message and sends it to the link2rsvp email account
     */
    async function contactUs(e) {
        e.preventDefault();
        const email = e.target.contactPage.value;
        const message = e.target.contactMessage.value;
        console.log(email);
        console.log(message);

        const contactUsData = {
            email: email,
            message: message
        }

        try {
            const response = await axios.post("https://link2rsvp.herokuapp.com/contactus", contactUsData);
            setSuccMessage(response.data.message);
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
        //clears form inputs
        document.getElementById('contactPage').value = '';
        document.getElementById('contactMessage').value='';
        return;
    }

    return (
        <div>
            {
                succMessage && (
                    <SuccMessage
                    message={succMessage}
                    clear={() => setSuccMessage(null)}
                    />
                )
            }
            {
                errorMessage && (
                    <ErrorMessage
                    message={errorMessage}
                    clear={() => setErrorMessage(null)}
                    />
                )
            }

            <div id="contact">
                <h4>Hello {userName}, What would you like to tell us?</h4>
                <Row>
                    <Col>
                <h3>Contact LINK2RSVP</h3>
                <p>If you have any questions or concerns, please let us know.</p>
                <Form onSubmit={contactUs}>
                    <Form.Group className="mb-3">
                        <label htmlFor="contactPage">Please enter your email:</label>
                        <Form.Control
                            id="contactPage"
                            type="email"
                            name="contactPage"
                            placeholder="email"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                        <label htmlFor="contactMessage">Please enter your message to us:</label>
                        <Form.Control
                            id="contactMessage"
                            name="contactMessage"
                            placeholder="enter your message here"
                            as="textarea"
                            row="5"
                            />
                        </Form.Group>
                    <Button
                    type="submit"
                    variant="secondary"
                    id="contact-btn"
                    style={{backgroundColor: "#890E32"}}
                    >Send</Button>
                </Form>
                </Col>
                <Col>
                <h3>LINK2RSVP Info</h3>
                <br></br>
                <p>&#9993; poc.demo.email@gmail.com</p>
                <p>&#9990; +0-000-000-0000</p>
                </Col>
                </Row>
            </div>
        </div>
    )
}

export default ContactLoggedIn;